import { profile, ProfileProps } from 'services/analytics/events/profile';

export const trackingProfileResponse = (operation: any, response: any) => {
  const metadata: ProfileProps = {
    '[Profile] Name': response.data.profileByIdentifier.name,
  };
  return profile.page.viewFeed(metadata);
};

export const trackingProfileEditStart = (name: string) => {
  const metadata: ProfileProps = {
    '[Profile] Name': name,
  };
  return profile.edit.intiate(metadata);
};

export const trackingProfileEditFinish = (name: string) => {
  const metadata: ProfileProps = {
    '[Profile] Name': name,
  };
  return profile.edit.complete(metadata);
};

// export const trackingProfileActivityFeed = (operation: any, response: any) => {
//   return;
// };
